import {PayrollAPI} from "../../../../apis/PayrollAPI.js";

window.CSV_FORMAT = {
    code: 'CSV',
    name: $filter('translate')('CSV'),
};

window.CSV_DETAILED_FORMAT = {
    code: 'CSV_DETAILS',
    name: $filter('translate')('CSV Detailed'),
};

window.EMAIL_SUMMARY_FORMAT = {
    code: 'HTML',
    name: $filter('translate')('Email Summary'),
};

window.EMAIL_TYPES = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
};

window.FREQUENCY = {
    ONCE: {
        name: $filter('translate')('Once'),
        code: 'ONCE'
    },
    DAILY: {
        name: $filter('translate')('Daily'),
        code: 'DAILY'
    },
    WEEKLY: {
        name: $filter('translate')('Weekly'),
        code: 'WEEKLY'
    },
    MONTHLY: {
        name: $filter('translate')('Monthly'),
        code: 'MONTHLY'
    },
};

window.HOURS = {
    '00': {name: '00', code: '00'},
    '01': {name: '01', code: '01'},
    '02': {name: '02', code: '02'},
    '03': {name: '03', code: '03'},
    '04': {name: '04', code: '04'},
    '05': {name: '05', code: '05'},
    '06': {name: '06', code: '06'},
    '07': {name: '07', code: '07'},
    '08': {name: '08', code: '08'},
    '09': {name: '09', code: '09'},
    '10': {name: '10', code: '10'},
    '11': {name: '11', code: '11'},
    '12': {name: '12', code: '12'},
    '13': {name: '13', code: '13'},
    '14': {name: '14', code: '14'},
    '15': {name: '15', code: '15'},
    '16': {name: '16', code: '16'},
    '17': {name: '17', code: '17'},
    '18': {name: '18', code: '18'},
    '19': {name: '19', code: '19'},
    '20': {name: '20', code: '20'},
    '21': {name: '21', code: '21'},
    '22': {name: '22', code: '22'},
    '23': {name: '23', code: '23'}
};

window.MINUTES = {
    '00': {name: '00', code: '00'},
    '15': {name: '15', code: '15'},
    '30': {name: '30', code: '30'},
    '45': {name: '45', code: '45'}
};

window.UTC_TIME_ZONE = {
    code: 'UTC',
    name: 'UTC'
};

window.REPORTS_ROUTES = {
    DETAILED_EMPLOYEE_LABOUR_REPORT: {
        team_live: 'appLayout.schedule.reports.detailed-employee-labor-report',
        source_hire: 'detailed-employee-labor-report'
    },
    FLASH_DASH_V2: {
        team_live: 'appLayout.schedule.reports.flash-report-v2',
        source_hire: 'flash-dash-v2'
    },
    TEAM_MEMBERS_MASTER_REPORT: {
        team_live: 'appLayout.schedule.reports.team-member-master-report',
        source_hire: 'team-member-master-report'
    },
    ENGAGEMENT_RATINGS_REPORT_SUMMARY: {
        source_hire: 'engagement-ratings'
    },
    RISK_ANALYSIS_DASHBOARD: {
        team_live: 'appLayout.schedule.tl-dashboards-risk',
        source_hire: 'risk-dashboard'
    },
    ENGAGEMENT_RATINGS_REPORT_DETAILED: {
        source_hire: 'engagement-ratings?tab=DETAILED'
    },
    ADP_EMPLOYEE_SYNC_STATUS_REPORT: {
        team_live: 'appLayout.schedule.reports.adp-employee-sync-status-report',
        source_hire: 'adp-employee-sync-status-report'
    },
    REWARDS_AUDIT_LOG_REPORT: {
        team_live: 'appLayout.schedule.reports.rewards-audit-log-report',
        source_hire: 'rewards-audit-log-report'
    },
    TIMESHEET_REPORT: {
        team_live: 'appLayout.schedule.reports.time-sheet-report',
        source_hire: 'time-sheet-report'
    },
    PAYROLL_REPORT: {
        source_hire: 'payroll-report'
    }
};
window.REPORTS_FROM_TYPES = {
    'GMT_ONLY': 'GMT_ONLY',
    'ALL': 'ALL'
}

window.REPORTS_WITH_EXTERNAL_EMAIL = [
    'RISK_ANALYSIS_DASHBOARD'
];

window.ScheduledExportsForm = function (scope, hUser, $state, userPermissions, $timeout, brandServices, dashboardsPrerequisiteService) {
    'use strict';

    const REPORT_VIEW_TYPES = {
        SYSTEM: 'SYSTEM'
    };

    const self = this;
    const formName = 'scheduled-exports-form';
    const _protected = BaseForm.call(self, formName, scope);

    self.data = {};
    self.availableReports = [];
    self.reportViews = [];
    self.allFrequencies = Object.keys(FREQUENCY).map(key => ({...FREQUENCY[key]}));
    self.frequencies = [...self.allFrequencies];
    self.startTimeHours = Object.keys(HOURS).map(key => ({...HOURS[key]})).sort((a, b) => a.code - b.code);
    self.startTimeMinutes = Object.keys(MINUTES).map(key => ({...MINUTES[key]})).sort((a, b) => a.code - b.code);
    self.timezones = [];
    self.passwordStrength = {};
    self.sftpConnectionTest = null;
    self.isLoading = false;
    self.isLoadingReportViews = false;
    self.isLoadingTestSftpConnection = false;
    self.hasScheduleReportsPermission = false;
    self.hasManageAllScheduleReportstPermission = false;
    self.availableRecipients = [];
    self.isLoadingRecipients = false;
    self.disableCustomizeYourView = true;
    self.isRiskAnalysisDashboard = false;
    self.riskActivationType = null;
    self.riskAccessMode = null;
    self.reportPermissionsStatus = {
        RISK_ANALYSIS_DASHBOARD: false,
        DETAILED_EMPLOYEE_LABOUR_REPORT: false,
        FLASH_DASH_V2: false,
        TEAM_MEMBERS_MASTER_REPORT: false,
        TIMESHEET_REPORT: false,
        ENGAGEMENT_RATINGS_REPORT_SUMMARY: false,
        ADP_EMPLOYEE_SYNC_STATUS_REPORT: false,
        REWARDS_AUDIT_LOG_REPORT: false,
        PAYROLL_REPORT: false
    };
    self.reportsPermissionsMap = {
        'FLASH_DASH_V2': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: []
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.ACCESS_FLASH_WAGE_TYPE_SUMMARY_REPORT],
            }
        },
        'DETAILED_EMPLOYEE_LABOUR_REPORT': {
            TEAM: {
                one_of_permissions: [
                    userPermissions.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_TIME_CARDS,
                    userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_TIME_CARDS,
                    userPermissions.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_TIME_CARDS,
                ],
                required_permissions: [],
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'TEAM_MEMBERS_MASTER_REPORT': {
            TEAM: {
                one_of_permissions: [
                    userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES,
                    userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES,
                    userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES
                ],
                required_permissions: []
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'TIMESHEET_REPORT': {
            TEAM: {
                one_of_permissions: [
                    userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES,
                    userPermissions.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_WAGES,
                    userPermissions.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES
                ],
                required_permissions: []
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'ENGAGEMENT_RATINGS_REPORT_SUMMARY': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.VIEW_TEAM_ENGAGEMENT]
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'RISK_ANALYSIS_DASHBOARD': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.ACCESS_RISK_DETECTION_DASHBOARD],
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'ADP_EMPLOYEE_SYNC_STATUS_REPORT': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.VIEW_ADP_EMPLOYEE_SYNC_STATUS_REPORT],
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        },
        'REWARDS_AUDIT_LOG_REPORT': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.VIEW_REWARDS_AND_RECOGNITION_AUDIT_LOG_REPORT],
            },
            HARRI: {
                one_of_permissions: [
                    userPermissions.PERMISSIONS.VIEW_JOB_POSTINGS,
                    userPermissions.PERMISSIONS.MANAGE_JOB_CANDIDATES,
                ],
                required_permissions: [],
            }
        },
        'PAYROLL_REPORT': {
            TEAM: {
                one_of_permissions: [],
                required_permissions: [userPermissions.PERMISSIONS.ACCESS_PAYROLL_REPORT],
            },
            HARRI: {
                one_of_permissions: [],
                required_permissions: [],
            }
        }
    };

    function prepareCustomizeYourViewLink() {
        let isSourceHire = false;
        if (hUser.hasSalesAccess() && self.hasAccessToSourceHire) {
            isSourceHire = true;
        }

        const route = REPORTS_ROUTES[self.data?.report?.code];

        if (!route) return null;

        if (isSourceHire) {
            return `${$state.href('appLayout.harriSH.reporting')}/${route.source_hire}`;
        }

        return $state.href(route.team_live);
    }

    function prepareSftpEmailExportOptions(reportCode) {
        const sftpFileFormats = [];
        const emailFileFormatsOptions = [];

        switch (reportCode) {
            case 'DETAILED_EMPLOYEE_LABOUR_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                break;
            case 'FLASH_DASH_V2':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                emailFileFormatsOptions.push(EMAIL_SUMMARY_FORMAT);
                break;
            case 'TEAM_MEMBERS_MASTER_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                sftpFileFormats.push(CSV_DETAILED_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_DETAILED_FORMAT);
                break;
            case 'TIMESHEET_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                sftpFileFormats.push(CSV_DETAILED_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_DETAILED_FORMAT);
                break;
            case 'RISK_ANALYSIS_DASHBOARD':
                emailFileFormatsOptions.push(EMAIL_SUMMARY_FORMAT);
                break;
            case 'ENGAGEMENT_RATINGS_REPORT_SUMMARY':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                emailFileFormatsOptions.push(EMAIL_SUMMARY_FORMAT);
                break;
            case 'ENGAGEMENT_RATINGS_REPORT_DETAILED':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                break;
            case 'ADP_EMPLOYEE_SYNC_STATUS_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                break;
            case 'REWARDS_AUDIT_LOG_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                break;
            case 'PAYROLL_REPORT':
                sftpFileFormats.push(CSV_FORMAT);
                emailFileFormatsOptions.push(CSV_FORMAT);
                break;
        }

        return {
            sftpFileFormats,
            emailFileFormatsOptions
        };
    }

    const loadRecipientsForReport = async (reportCode) => {
        if (!reportCode || !self.reportsPermissionsMap[reportCode]) {
            self.availableRecipients = [];
            return;
        }

        self.isLoadingRecipients = true;
        const reportPermissions = self.reportsPermissionsMap[reportCode];
        const allPermissions = new Set();

        Object.keys(reportPermissions).forEach(category => {
            const categoryPerms = reportPermissions[category];
            if (categoryPerms.required_permissions) {
                categoryPerms.required_permissions.forEach(perm => allPermissions.add(perm));
            }
            if (categoryPerms.one_of_permissions) {
                categoryPerms.one_of_permissions.forEach(perm => allPermissions.add(perm));
            }
        });

        try {
            const users = await PermissionsAPI.getBrandUsersByPermission(
                [self.groupId],
                Array.from(allPermissions),
                false
            );
            
            self.availableRecipients = users.map(user => ({
                harri_id: user.harri_id,
                team_user_id: user.team_user_id,
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                full_name: `${user.first_name} ${user.last_name}`.trim(),
                searchableText: `${user.first_name} ${user.last_name} ${user.email}`.trim()
            }));
        } catch (error) {
            console.error('Error loading recipients for report:', error);
            self.availableRecipients = [];
        } finally {
            self.isLoadingRecipients = false;
        }
    };

    self.load = async (modalData, prepareSftpPath) => {
        self.isLoading = true;
        self.groupId = hUser.getActiveBrandIdWithAccess();

        await checkAllReportPermissions(self.groupId);

        self.prepareSftpPath = prepareSftpPath;
        self.data.recipientEmail = null;
        self.data.usersLoginEmail = hUser.data.user.email;
        self.data.frequency = FREQUENCY.DAILY;
        self.data.ends = 'NEVER';
        self.data.sftpInputSwitch = true;
        self.data.isUserCreator = true;
        self.data.emailInputSwitch = false;
        self.data.emailType = EMAIL_TYPES.INTERNAL;
        self.data.externalEmail = null;
        self.data.sftpPortNumber = 22;
        self.data.startTimeHour = {...HOURS['00']};
        self.data.startTimeMinutes = {...MINUTES['00']};
        self.isRiskAnalysisDashboard = false;

        const requests = [
            brandServices.check(brandServices.SERVICES.REWARDS_AND_RECOGNITION, self.groupId, true),
            modalData.getAvailableReports(self.groupId),
            modalData.getCustomerTimezones(self.groupId),
            userPermissions.getBrandPolicy(self.groupId),
            dashboardsPrerequisiteService.canViewRiskDashboard(self.groupId, false, true),
            ReportingManagementAPI.getReportsServiceSettings(self.groupId),
            CoreHRUpdatesIntegartion.getCoreHrPayrollSettings(self.groupId),
            brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, self.groupId, true),
            ReportingSettingsManagementAPI.getServiceSettings(self.groupId, brandServices.SERVICES.RISK_DETECTION),
            userPermissions.hasPermissionOnBrandOrAnyChild(
                self.groupId,
                userPermissions.PERMISSIONS.MANAGE_ALL_SCHEDULED_REPORTS,
                userPermissions.PERMISSION_CATEGORIES.HARRI
            ),
            TeamLiveReportsAPI.getTeamLiveGroupSettings(self.groupId)
        ];

        if (modalData.id) {
            requests.push(GoodMorningToolEngineAPI.getScheduleExport(self.groupId, modalData.id));
        }

        let response;
        try {
            response = await Promise.all(requests);
        } catch (e) {
            console.error(e);
            self.isLoading = false;
            scope.$digest();
            return;
        }

        const [
            isRewardsAndRecognitionServiceEnabled,
            availableReports,
            timezones,
            policyParser,
            canViewRiskDashboard,
            availableReportsFromReportsService,
            coreHrPayrollSettings,
            isHarriEngageServiceEnabled,
            riskServiceSettings,
            hasManageAllScheduleReportstPermission,
            teamLiveGroupSettings,
            editedScheduleExport
        ] = response;
        const canViewRewardsAuditReport = isRewardsAndRecognitionServiceEnabled && policyParser.has(userPermissions.PERMISSIONS.VIEW_REWARDS_AND_RECOGNITION_AUDIT_LOG_REPORT);
        const prerequisites = {
            channelCode: coreHrPayrollSettings.channel_code,
            canViewRewardsAuditReport,
            teamLiveGroupSettings,
            canViewRiskDashboard,
            isHarriEngageServiceEnabled
        }

        const requiredPrerequisitesForReports = getRequiredPrerequisitesForReports(prerequisites);

        self.availableReports = filterBasedOnReportsFromReportsService(availableReports, availableReportsFromReportsService.reports, requiredPrerequisitesForReports);
        self.hasAccessOnHighestBrand = modalData.hasAccessOnHighestBrand;
        self.timezones = [UTC_TIME_ZONE, ...timezones];
        self.hasScheduleReportsPermission = policyParser.has(userPermissions.PERMISSIONS.SCHEDULE_REPORTS);
        self.hasManageAllScheduleReportstPermission = hasManageAllScheduleReportstPermission;
        self.hasAccessToSourceHire = policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE);
        self.riskActivationType = riskServiceSettings?.activation_settings?.type;
        self.riskAccessMode = riskServiceSettings?.activation_settings?.full_access_mode;
        self.data.sftpInputSwitch = self.hasManageAllScheduleReportstPermission;

        if (editedScheduleExport) {
            const lastRunStatus = editedScheduleExport.last_run_status || [];
            const sftpChannel = lastRunStatus.find(channel => channel.channel_type === 'SFTP');
            const emailChannel = lastRunStatus.find(channel => channel.channel_type === 'EMAIL');
            const startTime = editedScheduleExport.start_time.split(':');
            const hour = startTime[0];
            const minutes = startTime[1];

            self.data.exportName = editedScheduleExport.name;
            self.data.exportDescription = editedScheduleExport.description;
            self.data.report = {...self.availableReports.find(view => view.id === editedScheduleExport.report_view_id)};
            
            self.isRiskAnalysisDashboard = self.data.report?.code === 'RISK_ANALYSIS_DASHBOARD';

            await loadRecipientsForReport(self.data.report.code);
            
            self.data.frequency = {...FREQUENCY[editedScheduleExport.frequency.toUpperCase()]};
            self.data.startDate = editedScheduleExport.start_date;
            self.data.startTimeHour = {...HOURS[hour]};
            self.data.startTimeMinutes = {...MINUTES[minutes]};
            self.data.timezone = {...self.timezones.find(timezone => timezone.code === editedScheduleExport.timezone)};
            self.data.ends = editedScheduleExport.end_type;
            self.data.isUserCreator = hUser.getUser().id === editedScheduleExport.created_by_id;
            self.disabledStartDate = moment(self.data.startDate).isSameOrBefore(moment());

            if (['END_DATE', 'AFTER_OCCURRENCES'].includes(editedScheduleExport.end_type) &&
                editedScheduleExport.end_type_meta_data) {
                if (editedScheduleExport.end_type === 'END_DATE') {
                    self.data.endsOn = moment(editedScheduleExport.end_type_meta_data);
                } else {
                    self.data.occurrences = +editedScheduleExport.end_type_meta_data;
                }
            }

            if (sftpChannel) {
                const metaData = JSON.parse(sftpChannel.meta_data);
                const sftpFileFormats = [];
                const sftpPath = metaData.path || '';

                self.data.sftpInputSwitch = true;
                self.data.sftpHostNameOrAddress = metaData.hostname;
                self.data.sftpPortNumber = metaData.port;
                self.data.sftpPath = sftpPath === './.' ? '' : sftpPath;
                self.data.sftpUsername = metaData.username;
                self.data.sftpPassword = metaData.password;

                if (sftpChannel.formats.includes('CSV_DETAILS')) {
                    sftpFileFormats.push({...CSV_DETAILED_FORMAT});
                }

                if (sftpChannel.formats.includes('CSV')) {
                    sftpFileFormats.push({...CSV_FORMAT});
                }

                if (sftpChannel.formats.includes('HTML')) {
                    sftpFileFormats.push({...EMAIL_SUMMARY_FORMAT});
                }

                $timeout(() => {
                    self.data.sftpFileFormats = sftpFileFormats;
                });
            } else {
                self.data.sftpInputSwitch = false;
            }

            if (emailChannel) {
                const emailFileFormats = [];

                const emailObj = JSON.parse(emailChannel.meta_data);
                self.data.usersLoginEmail = emailObj?.email;

                if (emailChannel.formats.includes('CSV_DETAILS')) {
                    emailFileFormats.push({...CSV_DETAILED_FORMAT});
                }

                if (emailChannel.formats.includes('CSV')) {
                    emailFileFormats.push({...CSV_FORMAT});
                }

                if (emailChannel.formats.includes('HTML')) {
                    emailFileFormats.push({...EMAIL_SUMMARY_FORMAT});
                }

                $timeout(() => {
                    self.data.emailInputSwitch = true;
                    self.data.emailFileFormats = emailFileFormats;
                    
                    const savedEmailType = emailChannel.email_type;

                    if (savedEmailType === EMAIL_TYPES.EXTERNAL) {
                        self.data.emailType = EMAIL_TYPES.EXTERNAL;
                        self.data.externalEmail = emailObj?.email;
                    } else if (editedScheduleExport.recipient_user_id) {
                        self.data.emailType = EMAIL_TYPES.INTERNAL;
                        const recipientUser = self.availableRecipients.find(r => 
                            r.harri_id === Number(editedScheduleExport.recipient_user_id)
                        );
                        if (recipientUser) {
                            self.data.recipientEmail = recipientUser;
                        }
                        else {
                            self.data.recipientEmail = {email: emailObj?.email, harri_id: editedScheduleExport.recipient_user_id}
                        }
                    } else if (emailObj?.email) {
                        self.data.emailType = EMAIL_TYPES.EXTERNAL;
                        self.data.externalEmail = emailObj?.email;
                    }
                });
            } else {
                self.data.emailInputSwitch = false;
            }

            const {
                sftpFileFormats,
                emailFileFormatsOptions
            } = prepareSftpEmailExportOptions(self.data.report.code);

            self.sftpFileFormats = sftpFileFormats;
            self.emailFileFormatsOptions = emailFileFormatsOptions;
            self.isLoading = false;
            scope.$digest();

            await checkReportPermission(self.groupId, self.data.report.code);
            await self.reportChangeHandler(true);

            self.data.reportView = {
                id: editedScheduleExport.view_id,
                name: editedScheduleExport.report_view
            };
        }

        self.disableCustomizeYourView = !!prepareCustomizeYourViewLink();
        self.isLoading = false;
        scope.$digest();
    };

    const getRequiredPrerequisitesForReports = (prerequisites) => {
        return {
            'REWARDS_AUDIT_LOG_REPORT': {
                key: 'REWARDS_AUDIT_LOG_REPORT',
                isActive: () => prerequisites.canViewRewardsAuditReport
            },
            'ADP_EMPLOYEE_SYNC_STATUS_REPORT': {
                key:'ADP_EMPLOYEE_SYNC_STATUS_REPORT',
                isActive: () => prerequisites.channelCode === PayrollAPI.PAYROLL_CHANNELS.ADP
            },
            'ENGAGEMENT_RATINGS_REPORT': {
                key:'ENGAGEMENT_RATINGS_REPORT',
                isActive: () => prerequisites.isHarriEngageServiceEnabled
            },
            'RISK_ANALYSIS_DASHBOARD': {
                key: 'RISK_ANALYSIS_DASHBOARD',
                isActive: () => prerequisites.canViewRiskDashboard
            },
            'PAYROLL_REPORT': {
                key: 'PAYROLL_REPORT',
                isActive: () => prerequisites.teamLiveGroupSettings.brand_settings?.payroll_type_staffology
            }
        };
    };

    const filterBasedOnReportsFromReportsService = (reportsHasViews, availableReportsFromReportsService, requiredPrerequisitesForReports) => {
        const excludedReportCodes = ['ENGAGEMENT_RATINGS_REPORT_DETAILED'];
        const activatedReportCodes = new Set(availableReportsFromReportsService.map(report => report.code));
        if (activatedReportCodes.has(requiredPrerequisitesForReports.ADP_EMPLOYEE_SYNC_STATUS_REPORT.key) &&
            !requiredPrerequisitesForReports.ADP_EMPLOYEE_SYNC_STATUS_REPORT.isActive()) {
            activatedReportCodes.delete(requiredPrerequisitesForReports.ADP_EMPLOYEE_SYNC_STATUS_REPORT.key);
        }

        if (requiredPrerequisitesForReports.RISK_ANALYSIS_DASHBOARD.isActive()) {
            activatedReportCodes.add(requiredPrerequisitesForReports.RISK_ANALYSIS_DASHBOARD.key);
        } else {
            activatedReportCodes.delete(requiredPrerequisitesForReports.RISK_ANALYSIS_DASHBOARD.key);
        }

        if (requiredPrerequisitesForReports.ENGAGEMENT_RATINGS_REPORT.isActive()) {
            activatedReportCodes.add(requiredPrerequisitesForReports.ENGAGEMENT_RATINGS_REPORT.key);
        }
        if (activatedReportCodes.has(requiredPrerequisitesForReports.PAYROLL_REPORT.key) &&
            !requiredPrerequisitesForReports.PAYROLL_REPORT.isActive()) {
            activatedReportCodes.delete(requiredPrerequisitesForReports.PAYROLL_REPORT.key);
        }
        if (requiredPrerequisitesForReports.REWARDS_AUDIT_LOG_REPORT.isActive()) {
            activatedReportCodes.add(requiredPrerequisitesForReports.REWARDS_AUDIT_LOG_REPORT.key);
        }

        return reportsHasViews.filter(view => (activatedReportCodes.has(view.report_code) && !excludedReportCodes.includes(view.code)));
    };

    self.reportChangeHandler = async (isEditPrefilling) => {
        self.isLoadingReportViews = true;
        self.disableCustomizeYourView = false;
        self.reportViews = [];
        self.data.reportView = null;
        self.data.sftpFileFormats = null;
        self.data.emailFileFormats = null;

        const {
            sftpFileFormats,
            emailFileFormatsOptions
        } = prepareSftpEmailExportOptions(self.data.report.code);

        self.sftpFileFormats = sftpFileFormats;
        self.emailFileFormatsOptions = emailFileFormatsOptions;

        self.isRiskAnalysisDashboard = self.data.report.code === 'RISK_ANALYSIS_DASHBOARD';

        if (self.isRiskAnalysisDashboard) {
            self.frequencies = [FREQUENCY.WEEKLY];

            if (!isEditPrefilling) {
                self.data.sftpInputSwitch = false;
                self.data.emailInputSwitch = true;
                self.data.frequency = FREQUENCY.WEEKLY;
            }
        } else {
            self.frequencies = [...self.allFrequencies];
        }

        self.canExportSelectedReport = self.reportPermissionsStatus[self.data.report.code];

        if (!self.canExportSelectedReport && !isEditPrefilling && self.data.isUserCreator) {
            delete self.data.reportView;
            self.isLoadingReportViews = false;
            scope.$digest();
            return;
        }

        let response;
        try {
            response = await ReportingManagementAPI.getReportViews(self.groupId, self.data.report.code, null, REPORTS_FROM_TYPES.GMT_ONLY);
        } catch (e) {
            console.error(e);
            self.isLoadingReportViews = false;
            scope.$digest();
            return false;
        }

        self.reportViews = response;
        self.disableCustomizeYourView = !!prepareCustomizeYourViewLink();
        self.isLoadingReportViews = false;
        
        await loadRecipientsForReport(self.data.report.code);
        
        scope.$digest();
    };

    const checkAllReportPermissions = async (brandId) => {
        const reportPermissionsPromises = [];

        for (const reportCode in self.reportsPermissionsMap) {
            reportPermissionsPromises.push(checkReportPermission(brandId, reportCode));
        }

        try {
            const results = await Promise.all(reportPermissionsPromises);
            Object.keys(self.reportsPermissionsMap).forEach((reportCode, index) => {
                self.reportPermissionsStatus[reportCode] = results[index];
            });
        } catch (error) {
            HNotifications.show({
                title: $filter("translate")("Error") + ".",
                desc: $filter("translate")("Error checking all report permissions") + ' ' + error,
                icon: "fa-info-circle",
                type: "danger",
                timeout: 10000
            });
        }
    };

    const checkReportPermission = async (brandId, reportCode) => {
        const reportPermissions = self.reportsPermissionsMap[reportCode];
        const permissionPromises = [];
        const permissionCategories = [
            userPermissions.PERMISSION_CATEGORIES.TEAM,
            userPermissions.PERMISSION_CATEGORIES.HARRI
        ];

        for (let permissionCategory of permissionCategories) {
            if (reportPermissions[permissionCategory]) {
                const {required_permissions, one_of_permissions} = reportPermissions[permissionCategory];

                if (required_permissions.length > 0) {
                    permissionPromises.push(
                        userPermissions.hasPermissionOnBrandOrAnyChild(
                            brandId,
                            required_permissions,
                            permissionCategory,
                            one_of_permissions
                        )
                    );
                }

                if (one_of_permissions.length > 0 && required_permissions.length === 0) {
                    permissionPromises.push(
                        userPermissions.hasPermissionOnBrandOrAnyChild(
                            brandId,
                            null,
                            permissionCategory,
                            one_of_permissions
                        )
                    );
                }
            }
        }

        try {
            const results = await Promise.all(permissionPromises);
            const hasPermission = results.every(result => result === true);

            self.reportPermissionsStatus[reportCode] = hasPermission;

            return hasPermission;
        } catch (error) {
            hAlert(`Error checking report permissions: ${error}`);
            self.reportPermissionsStatus[reportCode] = false;
            return false;
        }
    };

    self.customizeYourViewHandler = () => {
        window.open(prepareCustomizeYourViewLink(), '_blank');
    };

    self.isAllSftpFieldsFilled = () => {
        return (
            !!self.data.sftpHostNameOrAddress &&
            !!self.data.sftpPortNumber &&
            !!self.data.sftpUsername &&
            !!self.data.sftpPassword
        );
    };

    self.validate = () => {
        self.noneOfChannelsSelected = false;

        const deferred = $q.defer();
        const noneOfChannelsSelected = !self.data.sftpInputSwitch && !self.data.emailInputSwitch;

        self.noneOfChannelsSelected = noneOfChannelsSelected;

        if (!self.validator.validate() || noneOfChannelsSelected) {
            deferred.reject({code: "validate_error"});
            return deferred.promise;
        }
    };

    self.destroy = () => {
        self.validator.validation = {};
    };

    self.testSftpConnection = async () => {
        self.isLoadingTestSftpConnection = true;
        self.sftpConnectionTest = null;

        let response;
        try {
            response = await GoodMorningToolEngineAPI.testConnection(
                self.groupId,
                self.data.sftpHostNameOrAddress,
                self.data.sftpPortNumber,
                self.prepareSftpPath(self.data.sftpPath, self.data.sftpUsername),
                self.data.sftpUsername,
                self.data.sftpPassword,
                'SFTP'
            );
        } catch (e) {
            console.error(e);
            self.isLoadingTestSftpConnection = false;
            scope.$digest();
            return;
        }

        self.isLoadingTestSftpConnection = false;
        self.sftpConnectionTest = response.status;
        setTimeout(() => {
            self.sftpConnectionTest = null;
            scope.$digest();
        }, 1500);
        scope.$digest();
    };

    self.validator.validateCustom = (field, optionsField, rule, showError) => {
        switch (rule.name) {
            case 'endsOn':
                if (self.data.startDate && self.data.endsOn && self.data.ends === 'END_DATE') {
                    const startDate = moment(self.data.startDate);
                    const endsOnDate = moment(self.data.endsOn);

                    if (endsOnDate.isSameOrBefore(startDate)) {
                        if (showError) {
                            self.validator.validation[rule.name].errors[rule.name] = true;
                        }

                        return false;
                    }
                }

                break;

            case 'todayOrFutureDate':
                const startDate = moment(self.data.startDate).startOf('day').local();
                const todayDate = moment().startOf('day').local();

                if (startDate.isBefore(todayDate)) {
                    return false;
                }

                break;
        }

        return true;
    };

    self.canShowEditableRecipientEmailSelector = () => {
        return self.hasManageAllScheduleReportstPermission &&
            self.hasAccessOnHighestBrand &&
            self.data.reportView?.type === REPORT_VIEW_TYPES.SYSTEM;
    };

    self.canShowExternalEmailOption = () => {
        const supportsExternalEmail = REPORTS_WITH_EXTERNAL_EMAIL.includes(self.data.report?.code);

        if (supportsExternalEmail && self.data.report?.code === 'RISK_ANALYSIS_DASHBOARD') {
            if (self.riskAccessMode === 'SINGLE') {
                return false;
            }
        }

        return supportsExternalEmail;
    };

    self.reportViewChangeHandler = () => {
        if (self.data.recipientEmail) {
            self.data.recipientEmail = null;
        }
        
        if (self.data.reportView?.type === REPORT_VIEW_TYPES.SYSTEM && self.canShowEditableRecipientEmailSelector()) {
            const currentUser = self.availableRecipients.find(recipient => 
                recipient.email === self.data.usersLoginEmail
            );
            if (currentUser) {
                self.data.recipientEmail = currentUser;
            }
        }
    };
};